import { FC, SVGProps } from 'react';

const ErrorTriangleIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  color = '#E7951D',
  size = 20,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.004 20.1007H4.99575C3.46195 20.1007 2.50321 18.4407 3.26962 17.1118L10.3179 4.89678C11.0872 3.56308 13.0135 3.56794 13.776 4.90552L20.7359 17.1206C21.4926 18.4494 20.5329 20.1007 19.004 20.1007Z"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.0117 13.2827V10.2715M12.0098 16.328V16.2794"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ErrorTriangleIcon;
